import React, { useEffect, useState, useRef } from 'react';
import { useWeather } from '../../context';

const tourSteps = [
  {
    target: '[data-tour="model-selector"]',
    content: 'Start by selecting your weather data source. Choose between Catamaran Weather for historical weather data or Catamaran SCS for storm reports.'
  },
  {
    target: '[data-tour="mode-selector"]',
    content: 'Choose between polygon or point mode for selecting your area of interest.'
  },
  {
    target: '[data-tour="parameter-selector"]',
    content: 'Select the weather parameter you want to analyze.'
  },
  {
    target: '[data-tour="resolution-selector"]',
    content: 'For weather data, adjust the grid resolution. Lower values provide more detail but take longer to process.'
  },
  {
    target: '[data-tour="date-selector"]',
    content: 'Select your date range for analysis.'
  },
  {
    target: '[data-tour="map"]',
    content: 'Draw your area of interest on the map using the polygon tool.'
  },
  {
    target: '[data-tour="fetch-button"]',
    content: 'Click Fetch Data to retrieve and analyze the weather data for your selected area.'
  }
];

export function TourGuide() {
  const [currentStep, setCurrentStep] = useState(0);
  const [showTour, setShowTour] = useState(true);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const { modelSelect } = useWeather();

  useEffect(() => {
    const hasSeenTour = localStorage.getItem('hasSeenTour');
    if (hasSeenTour) {
      setShowTour(false);
    }
  }, []);

  useEffect(() => {
    const step = tourSteps[currentStep];
    const element = document.querySelector(step.target);
    if (element) {
      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      
      // Calculate position based on element location
      let top = rect.bottom + 10;
      let left = rect.left;

      // Adjust if popup would go off screen
      if (top + 200 > windowHeight) {
        top = rect.top - 210;
      }
      if (left + 400 > windowWidth) {
        left = windowWidth - 420;
      }
      if (left < 20) left = 20;

      setPopupPosition({ top, left });
    }
  }, [currentStep]);

  const nextStep = () => {
    if (currentStep < tourSteps.length - 1) {
      setCurrentStep(prev => prev + 1);
    } else {
      endTour();
    }
  };

  const endTour = () => {
    setShowTour(false);
    localStorage.setItem('hasSeenTour', 'true');
  };

  if (!showTour) return null;

  const step = tourSteps[currentStep];
  const isLastStep = currentStep === tourSteps.length - 1;

  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={endTour} />
      <div 
        className="absolute glass-panel p-4 max-w-md"
        style={{
          top: popupPosition.top,
          left: popupPosition.left,
          transform: 'none',
          zIndex: 51
        }}
      >
        <h3 className="text-lg font-semibold mb-2">Welcome to Weather Explorer</h3>
        <p className="text-[var(--secondary-text)] mb-4">{step.content}</p>
        <div className="flex justify-between">
          <button 
            onClick={endTour}
            className="btn btn-secondary"
          >
            Skip Tour
          </button>
          <button 
            onClick={nextStep}
            className="btn"
          >
            {isLastStep ? 'Get Started' : 'Next'}
          </button>
        </div>
      </div>
    </div>
  );
}